import {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

class WarningModal extends Component {
        constructor(props) {
            super(props);
            this.state={
        }
    }       
         
    render() {
  
   
    return <>
        <Modal show={this.props.show} size="med" animation={false}>
          <Modal.Header className="warningModalHdrFtrBackground mb-0" closeButton>
              <Modal.Title>
                    <div className="font-weight-bold text-yellow">{this.props.warningTitle}
                        </div>
              </Modal.Title>
          </Modal.Header>
          <Modal.Body  className="warningModalHdrFtrBackground mb-0">
              <div>
                    {this.props.warningMsg}
              </div>
           </Modal.Body>
          <Modal.Footer className="warningModalHdrFtrBackground text-right">
            <Button className="mr-1" variant="primary"   onClick={() => this.props.onClose("goback")}>
                  Go Back and Confirm
            </Button>
            <Button className="mr-1" variant="primary"   onClick={() => this.props.onClose("discard")}>
                  Discard Changes and Close
            </Button>
          </Modal.Footer>
          </Modal>  
    </>
}         

}

export default WarningModal;